let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hXddo")).then(() => parcelRequire('k9wdm'));